<template>
  <div id="app" :class="[classBase + 'app', grayBody ? 'gary-body' : '']">
    <router-view />
    <!-- 登录 -->
    <Login />
    <!-- 实名认证 -->
    <AuthRealName />
    <!-- 青少年检查 -->
    <CheckUnderage />
    <!-- 登录认证提示 -->
    <LoginVerifyTips />
  </div>
</template>
<script>
// plugins
import Login from "@/layout/wiki/components/login.vue";
import AuthRealName from "@/layout/wiki/components/adultCheck.vue";
import CheckUnderage from "@/layout/wiki/components/checkUnderage.vue";
import LoginVerifyTips from "@/layout/wiki/components/loginVerifyTips.vue";
// api
import { apiGetWechatMiniAppQrcode, apiGetWechatServiceQrcode } from "@/api/wechatApi";
import { setupLinkInterceptors } from "@/components/LinkInterceptor/interceptors";

export default {
  components: {
    Login,
    AuthRealName,
    CheckUnderage,
    LoginVerifyTips
  },
  provide: function() {
    return {
      getWxaQrcode: this.getWxaQrcode,
      getServiceQrcodeSrc: this.getServiceQrcodeSrc
    };
  },
  data() {
    return {
      token: this.$route.query.token || "",
      grayBody: false,
      wxaQrcode: "",
      timer: null
    };
  },
  computed: {},

  watch: {
    $route: "routeWatch"
  },
  async created() {
    // 设置网页灰色
    this.routeWatch();
  },
  async beforeMount() {
    // 获取用户信息
    await this.$store.dispatch("getUserInfo");

    // 获取服务号二维码
    this.getServiceQrcode();

    // 青少年模式检查
    // eventBus.$emit("checkUnderage");

    // 设置全局鼠标样式
    const mouseImg = this.$store.getters.gameInfo.mouse_css || "";
    if (mouseImg) {
      document.body.style.cursor = `url(${mouseImg}), auto`;
    }
    if (window.isAppPage && window.goPage) {
      this.$router.replace(window.goPage);
    }
    this.setupLinkInterceptors();
  },
  mounted() {
    // 页面登录刷新后跳转
    const login_status = sessionStorage.getItem("login_status");
    const need_jump_path = sessionStorage.getItem("login_jump_path");
    if (login_status == 1) {
      sessionStorage.removeItem("login_status");
      if (need_jump_path) {
        sessionStorage.removeItem("login_jump_path");
        this.$router.push(need_jump_path);
      }
    } else if (this.$route.name != "callback") {
      sessionStorage.removeItem("login_status");
      if (need_jump_path) {
        sessionStorage.removeItem("login_jump_path");
      }
    }
  },
  beforeDestroy() {},
  methods: {
    // 设置链接拦截器
    setupLinkInterceptors,
    // 监听路由
    routeWatch() {
      if (this.$route.meta.grayBody) {
        this.grayBody = true;
      } else {
        this.grayBody = false;
      }
    },
    getWxQrcode() {
      const appMode = process.env.VUE_APP_MODE;
      return apiGetWechatMiniAppQrcode({
        env_version: appMode === "prod" ? "release" : "release",
        path: "pages/start/index"
      }).then(res => {
        const src = "data:image/png;base64," + window.btoa(String.fromCharCode(...new Uint8Array(res)));
        /** 二维码1小时过期，重新获取 */
        setTimeout(() => {
          this.getWxQrcode();
        }, 1000 * 60 * 60);
        this.wxaQrcode = src;
        return src;
      });
    },
    getServiceQrcode() {
      apiGetWechatServiceQrcode({ source: 2 }).then(res => {
        this.serviceQrcodeSrc = res.data.qr_code;
        this.$store.commit("set_serviceQrcodeSrc", res.data.qr_code);
        /** 二维码1小时过期，重新获取 */
        setTimeout(() => {
          this.getServiceQrcode();
        }, 1000 * 60 * 60);
      });
    },

    getWxaQrcode() {
      if (this.wxaQrcode) {
        return this.wxaQrcode;
      }

      return this.getWxQrcode();
    },
    getServiceQrcodeSrc() {
      return this.serviceQrcodeSrc;
    }
  }
};
</script>
<style lang="less" scoped>
.pc-app {
  max-width: 100%;
  /* overflow: auto; */
}

// 页面置灰
.gary-body {
  -webkit-filter: grayscale(100%); /* webkit */
  -moz-filter: grayscale(100%); /*firefox*/
  -ms-filter: grayscale(100%); /*ie9*/
  -o-filter: grayscale(100%); /*opera*/
  filter: grayscale(100%);
  filter: progid:DXImageTransform.Microsoft.BasicImage(grayscale=1);
}
</style>
<style>
.tippy-box[data-theme~="light"] {
  background-color: #fff;
  color: #404040;
  border-radius: 4px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2), 0 0 6px rgba(0, 0, 0, 0.1);
}
.tippy-box[data-theme~="light"] .tippy-content,
.tippy-box[data-theme~="dark"] .tippy-content {
  padding: 0;
}
.tippy-box[data-theme~="light"] .tippy-arrow {
  color: #fff;
}
.contextmenu {
  padding: 6px 0;
}
.contextmenu-item {
  line-height: 26px;
  padding: 0 10px;
  cursor: pointer;
  transition: background-color 300ms, color 300ms;
  white-space: nowrap;
}
.contextmenu-item:hover {
  color: #fff;
  background-color: #3e55e1;
}
</style>
<style>
/** 临时处理回复、评论提示 */
.__temp_toast__ {
  position: fixed;
  z-index: 9999;
  background-color: rgba(0, 0, 0, 0.6);
  border-radius: 4px;
  text-align: center;
  padding: 12px 32px;
  left: 50%;
  transform: translateX(-50%);
  top: 10vh;
  color: #fff;
  font-size: 20px;
}
</style>
